/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as MainRouteImport } from './routes/_main/route'
import { Route as UpgradeCompletedImport } from './routes/upgrade/completed'
import { Route as MainTenantRouteImport } from './routes/_main/tenant/route'
import { Route as MainProjectRouteImport } from './routes/_main/_project/route'
import { Route as MainTenantIndexImport } from './routes/_main/tenant/index'
import { Route as MainProjectIndexImport } from './routes/_main/_project/index'
import { Route as MainProjectWelcomeImport } from './routes/_main/_project/welcome'
import { Route as MainProjectProjectRouteImport } from './routes/_main/_project/project/route'
import { Route as MainTenantUsersIndexImport } from './routes/_main/tenant/users/index'
import { Route as MainTenantUsageIndexImport } from './routes/_main/tenant/usage/index'
import { Route as MainTenantSettingsIndexImport } from './routes/_main/tenant/settings/index'
import { Route as MainTenantProjectsIndexImport } from './routes/_main/tenant/projects/index'
import { Route as MainTenantLimitsIndexImport } from './routes/_main/tenant/limits/index'
import { Route as MainProjectUpgradeIndexImport } from './routes/_main/_project/upgrade/index'
import { Route as MainProjectProjectIndexImport } from './routes/_main/_project/project/index'
import { Route as MainProjectProfileIndexImport } from './routes/_main/_project/profile/index'
import { Route as MainTenantUsersSendInvitationImport } from './routes/_main/tenant/users/send-invitation'
import { Route as MainProjectUpgradeCancelledImport } from './routes/_main/_project/upgrade/cancelled'
import { Route as MainProjectProjectUsageIndexImport } from './routes/_main/_project/project/usage/index'
import { Route as MainProjectProjectSettingsIndexImport } from './routes/_main/_project/project/settings/index'
import { Route as MainProjectProjectMembersIndexImport } from './routes/_main/_project/project/members/index'
import { Route as MainProjectProjectApiKeysIndexImport } from './routes/_main/_project/project/api-keys/index'

// Create/Update Routes

const MainRouteRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRoute,
} as any)

const UpgradeCompletedRoute = UpgradeCompletedImport.update({
  path: '/upgrade/completed',
  getParentRoute: () => rootRoute,
} as any)

const MainTenantRouteRoute = MainTenantRouteImport.update({
  path: '/tenant',
  getParentRoute: () => MainRouteRoute,
} as any)

const MainProjectRouteRoute = MainProjectRouteImport.update({
  id: '/_project',
  getParentRoute: () => MainRouteRoute,
} as any)

const MainTenantIndexRoute = MainTenantIndexImport.update({
  path: '/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainProjectIndexRoute = MainProjectIndexImport.update({
  path: '/',
  getParentRoute: () => MainProjectRouteRoute,
} as any)

const MainProjectWelcomeRoute = MainProjectWelcomeImport.update({
  path: '/welcome',
  getParentRoute: () => MainProjectRouteRoute,
} as any)

const MainProjectProjectRouteRoute = MainProjectProjectRouteImport.update({
  path: '/project',
  getParentRoute: () => MainProjectRouteRoute,
} as any)

const MainTenantUsersIndexRoute = MainTenantUsersIndexImport.update({
  path: '/users/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainTenantUsageIndexRoute = MainTenantUsageIndexImport.update({
  path: '/usage/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainTenantSettingsIndexRoute = MainTenantSettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainTenantProjectsIndexRoute = MainTenantProjectsIndexImport.update({
  path: '/projects/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainTenantLimitsIndexRoute = MainTenantLimitsIndexImport.update({
  path: '/limits/',
  getParentRoute: () => MainTenantRouteRoute,
} as any)

const MainProjectUpgradeIndexRoute = MainProjectUpgradeIndexImport.update({
  path: '/upgrade/',
  getParentRoute: () => MainProjectRouteRoute,
} as any)

const MainProjectProjectIndexRoute = MainProjectProjectIndexImport.update({
  path: '/',
  getParentRoute: () => MainProjectProjectRouteRoute,
} as any)

const MainProjectProfileIndexRoute = MainProjectProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => MainProjectRouteRoute,
} as any)

const MainTenantUsersSendInvitationRoute =
  MainTenantUsersSendInvitationImport.update({
    path: '/users/send-invitation',
    getParentRoute: () => MainTenantRouteRoute,
  } as any)

const MainProjectUpgradeCancelledRoute =
  MainProjectUpgradeCancelledImport.update({
    path: '/upgrade/cancelled',
    getParentRoute: () => MainProjectRouteRoute,
  } as any)

const MainProjectProjectUsageIndexRoute =
  MainProjectProjectUsageIndexImport.update({
    path: '/usage/',
    getParentRoute: () => MainProjectProjectRouteRoute,
  } as any)

const MainProjectProjectSettingsIndexRoute =
  MainProjectProjectSettingsIndexImport.update({
    path: '/settings/',
    getParentRoute: () => MainProjectProjectRouteRoute,
  } as any)

const MainProjectProjectMembersIndexRoute =
  MainProjectProjectMembersIndexImport.update({
    path: '/members/',
    getParentRoute: () => MainProjectProjectRouteRoute,
  } as any)

const MainProjectProjectApiKeysIndexRoute =
  MainProjectProjectApiKeysIndexImport.update({
    path: '/api-keys/',
    getParentRoute: () => MainProjectProjectRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRoute
    }
    '/_main/_project': {
      id: '/_main/_project'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainProjectRouteImport
      parentRoute: typeof MainRouteImport
    }
    '/_main/tenant': {
      id: '/_main/tenant'
      path: '/tenant'
      fullPath: '/tenant'
      preLoaderRoute: typeof MainTenantRouteImport
      parentRoute: typeof MainRouteImport
    }
    '/upgrade/completed': {
      id: '/upgrade/completed'
      path: '/upgrade/completed'
      fullPath: '/upgrade/completed'
      preLoaderRoute: typeof UpgradeCompletedImport
      parentRoute: typeof rootRoute
    }
    '/_main/_project/project': {
      id: '/_main/_project/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof MainProjectProjectRouteImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/_project/welcome': {
      id: '/_main/_project/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof MainProjectWelcomeImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/_project/': {
      id: '/_main/_project/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainProjectIndexImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/tenant/': {
      id: '/_main/tenant/'
      path: '/'
      fullPath: '/tenant/'
      preLoaderRoute: typeof MainTenantIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/_project/upgrade/cancelled': {
      id: '/_main/_project/upgrade/cancelled'
      path: '/upgrade/cancelled'
      fullPath: '/upgrade/cancelled'
      preLoaderRoute: typeof MainProjectUpgradeCancelledImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/tenant/users/send-invitation': {
      id: '/_main/tenant/users/send-invitation'
      path: '/users/send-invitation'
      fullPath: '/tenant/users/send-invitation'
      preLoaderRoute: typeof MainTenantUsersSendInvitationImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/_project/profile/': {
      id: '/_main/_project/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainProjectProfileIndexImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/_project/project/': {
      id: '/_main/_project/project/'
      path: '/'
      fullPath: '/project/'
      preLoaderRoute: typeof MainProjectProjectIndexImport
      parentRoute: typeof MainProjectProjectRouteImport
    }
    '/_main/_project/upgrade/': {
      id: '/_main/_project/upgrade/'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof MainProjectUpgradeIndexImport
      parentRoute: typeof MainProjectRouteImport
    }
    '/_main/tenant/limits/': {
      id: '/_main/tenant/limits/'
      path: '/limits'
      fullPath: '/tenant/limits'
      preLoaderRoute: typeof MainTenantLimitsIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/tenant/projects/': {
      id: '/_main/tenant/projects/'
      path: '/projects'
      fullPath: '/tenant/projects'
      preLoaderRoute: typeof MainTenantProjectsIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/tenant/settings/': {
      id: '/_main/tenant/settings/'
      path: '/settings'
      fullPath: '/tenant/settings'
      preLoaderRoute: typeof MainTenantSettingsIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/tenant/usage/': {
      id: '/_main/tenant/usage/'
      path: '/usage'
      fullPath: '/tenant/usage'
      preLoaderRoute: typeof MainTenantUsageIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/tenant/users/': {
      id: '/_main/tenant/users/'
      path: '/users'
      fullPath: '/tenant/users'
      preLoaderRoute: typeof MainTenantUsersIndexImport
      parentRoute: typeof MainTenantRouteImport
    }
    '/_main/_project/project/api-keys/': {
      id: '/_main/_project/project/api-keys/'
      path: '/api-keys'
      fullPath: '/project/api-keys'
      preLoaderRoute: typeof MainProjectProjectApiKeysIndexImport
      parentRoute: typeof MainProjectProjectRouteImport
    }
    '/_main/_project/project/members/': {
      id: '/_main/_project/project/members/'
      path: '/members'
      fullPath: '/project/members'
      preLoaderRoute: typeof MainProjectProjectMembersIndexImport
      parentRoute: typeof MainProjectProjectRouteImport
    }
    '/_main/_project/project/settings/': {
      id: '/_main/_project/project/settings/'
      path: '/settings'
      fullPath: '/project/settings'
      preLoaderRoute: typeof MainProjectProjectSettingsIndexImport
      parentRoute: typeof MainProjectProjectRouteImport
    }
    '/_main/_project/project/usage/': {
      id: '/_main/_project/project/usage/'
      path: '/usage'
      fullPath: '/project/usage'
      preLoaderRoute: typeof MainProjectProjectUsageIndexImport
      parentRoute: typeof MainProjectProjectRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  MainRouteRoute: MainRouteRoute.addChildren({
    MainProjectRouteRoute: MainProjectRouteRoute.addChildren({
      MainProjectProjectRouteRoute: MainProjectProjectRouteRoute.addChildren({
        MainProjectProjectIndexRoute,
        MainProjectProjectApiKeysIndexRoute,
        MainProjectProjectMembersIndexRoute,
        MainProjectProjectSettingsIndexRoute,
        MainProjectProjectUsageIndexRoute,
      }),
      MainProjectWelcomeRoute,
      MainProjectIndexRoute,
      MainProjectUpgradeCancelledRoute,
      MainProjectProfileIndexRoute,
      MainProjectUpgradeIndexRoute,
    }),
    MainTenantRouteRoute: MainTenantRouteRoute.addChildren({
      MainTenantIndexRoute,
      MainTenantUsersSendInvitationRoute,
      MainTenantLimitsIndexRoute,
      MainTenantProjectsIndexRoute,
      MainTenantSettingsIndexRoute,
      MainTenantUsageIndexRoute,
      MainTenantUsersIndexRoute,
    }),
  }),
  UpgradeCompletedRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_main",
        "/upgrade/completed"
      ]
    },
    "/_main": {
      "filePath": "_main/route.tsx",
      "children": [
        "/_main/_project",
        "/_main/tenant"
      ]
    },
    "/_main/_project": {
      "filePath": "_main/_project/route.tsx",
      "parent": "/_main",
      "children": [
        "/_main/_project/project",
        "/_main/_project/welcome",
        "/_main/_project/",
        "/_main/_project/upgrade/cancelled",
        "/_main/_project/profile/",
        "/_main/_project/upgrade/"
      ]
    },
    "/_main/tenant": {
      "filePath": "_main/tenant/route.tsx",
      "parent": "/_main",
      "children": [
        "/_main/tenant/",
        "/_main/tenant/users/send-invitation",
        "/_main/tenant/limits/",
        "/_main/tenant/projects/",
        "/_main/tenant/settings/",
        "/_main/tenant/usage/",
        "/_main/tenant/users/"
      ]
    },
    "/upgrade/completed": {
      "filePath": "upgrade/completed.tsx"
    },
    "/_main/_project/project": {
      "filePath": "_main/_project/project/route.tsx",
      "parent": "/_main/_project",
      "children": [
        "/_main/_project/project/",
        "/_main/_project/project/api-keys/",
        "/_main/_project/project/members/",
        "/_main/_project/project/settings/",
        "/_main/_project/project/usage/"
      ]
    },
    "/_main/_project/welcome": {
      "filePath": "_main/_project/welcome.tsx",
      "parent": "/_main/_project"
    },
    "/_main/_project/": {
      "filePath": "_main/_project/index.tsx",
      "parent": "/_main/_project"
    },
    "/_main/tenant/": {
      "filePath": "_main/tenant/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/_project/upgrade/cancelled": {
      "filePath": "_main/_project/upgrade/cancelled.tsx",
      "parent": "/_main/_project"
    },
    "/_main/tenant/users/send-invitation": {
      "filePath": "_main/tenant/users/send-invitation.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/_project/profile/": {
      "filePath": "_main/_project/profile/index.tsx",
      "parent": "/_main/_project"
    },
    "/_main/_project/project/": {
      "filePath": "_main/_project/project/index.tsx",
      "parent": "/_main/_project/project"
    },
    "/_main/_project/upgrade/": {
      "filePath": "_main/_project/upgrade/index.tsx",
      "parent": "/_main/_project"
    },
    "/_main/tenant/limits/": {
      "filePath": "_main/tenant/limits/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/tenant/projects/": {
      "filePath": "_main/tenant/projects/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/tenant/settings/": {
      "filePath": "_main/tenant/settings/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/tenant/usage/": {
      "filePath": "_main/tenant/usage/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/tenant/users/": {
      "filePath": "_main/tenant/users/index.tsx",
      "parent": "/_main/tenant"
    },
    "/_main/_project/project/api-keys/": {
      "filePath": "_main/_project/project/api-keys/index.tsx",
      "parent": "/_main/_project/project"
    },
    "/_main/_project/project/members/": {
      "filePath": "_main/_project/project/members/index.tsx",
      "parent": "/_main/_project/project"
    },
    "/_main/_project/project/settings/": {
      "filePath": "_main/_project/project/settings/index.tsx",
      "parent": "/_main/_project/project"
    },
    "/_main/_project/project/usage/": {
      "filePath": "_main/_project/project/usage/index.tsx",
      "parent": "/_main/_project/project"
    }
  }
}
ROUTE_MANIFEST_END */
